import { Container, NineSliceSprite, Texture, Sprite } from 'pixi.js';

export enum SpeechBubbleSide {
  Bottom = 'Bottom',
  Top = 'Top',
  Left = 'Left',
  Right = 'Right',
}

export interface SpeechBubbleConfig {
  pointer: { side: SpeechBubbleSide; anchor: number };
  body: { width: number; height: number };
}

export class SpeechBubbleView extends Container {
  private readonly contentContainer: Container;

  private readonly bodySettings = {
    texture: Texture.from('Speech_Bubble_Body'),
    leftWidth: 22,
    rightWidth: 22,
    topHeight: 22,
    bottomHeight: 22,
  };

  private readonly pointSettings = {
    texture: Texture.from('Speech_Bubble_Point'),
    pointerLength: 26,
    pointerSide: 15,
  };

  constructor(config: SpeechBubbleConfig) {
    super();
    const body = this.createBody(config);
    this.createPoint(config.pointer);
    this.alignBody(body, config.pointer);
    this.contentContainer = new Container().props({
      x: body.x + body.width * 0.5,
      y: body.y + body.height * 0.5,
      parent: this,
    });
  }

  public getContentContainer(): Container {
    return this.contentContainer;
  }

  private createPoint(anchor: SpeechBubbleConfig['pointer']): Sprite {
    const angle = {
      [SpeechBubbleSide.Bottom]: 0,
      [SpeechBubbleSide.Top]: 180,
      [SpeechBubbleSide.Left]: 90,
      [SpeechBubbleSide.Right]: 270,
    }[anchor.side];

    return new Sprite().props({
      ...this.pointSettings,
      anchor: { x: 0.5, y: 1 },
      angle,
      parent: this,
    });
  }

  private createBody(config: SpeechBubbleConfig): NineSliceSprite {
    return new NineSliceSprite({
      width: Math.max(70, config.body.width),
      height: Math.max(70, config.body.height),
      parent: this,
      ...this.bodySettings,
    }).props({});
  }

  private alignBody(body: NineSliceSprite, anchor: SpeechBubbleConfig['pointer']): void {
    const { leftWidth, rightWidth, topHeight, bottomHeight } = this.bodySettings;
    const { pointerLength, pointerSide } = this.pointSettings;

    // point up or down
    const availableWidth = body.width - leftWidth - rightWidth - pointerSide * 2;
    const availableHeight = body.height - topHeight - bottomHeight - pointerSide * 2;

    if (anchor.side === SpeechBubbleSide.Bottom || anchor.side === SpeechBubbleSide.Top) {
      body.props({
        x: -(leftWidth + pointerSide + availableWidth * anchor.anchor),
        y: anchor.side === SpeechBubbleSide.Top ? pointerLength : -body.height - pointerLength + 1,
      });
    } else {
      body.props({
        x: anchor.side === SpeechBubbleSide.Left ? pointerLength : -body.width - pointerLength,
        y: -(topHeight + pointerSide + availableHeight * anchor.anchor),
      });
    }
  }
}
